export default function({ state, commit, dispatch }, reminder) {

    let patientId = reminder.patient
    delete reminder.patient

    commit('startSendingReminder')

    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : reminder.provider ) + '/patient/' + patientId + '/reminder',
        data: reminder
    }, {
        root: true
    })
        .then((response) => {
            console.log('RES', response)
            try {
                commit('setReminderTime', {
                    patient: patientId,
                    message: reminder.id
                })
            } catch (error) {
                console.error('Could not set reminder time', error)
            }
            commit('finishSendingReminder')
            return response
        })
        .catch((error) => {
            commit('finishSendingReminder')
            throw error
        })
}
